// extracted by mini-css-extract-plugin
export var avatarHelper = "sign-up-requirements-sso-user-module--avatarHelper--0f9b9";
export var avatarSelect = "sign-up-requirements-sso-user-module--avatarSelect--88fbf";